import { Typography } from '@mui/material';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import InformationalSection from '~/components/InformationalSection';
import { useOtherTeamLeaders } from '~/hooks/api/useOtherTeamLeaders';
import Spacings from '~/modules/ui-kit/spacings';
import { toNational } from '~/utils/phone-number-helpers';
import messages from './messages';
import styles from './styles.module.css';

type ShiftTurnLeadersProps = {
  onPublisherClick: (publisher: { id: number; phone: string }) => void;
  settings: {
    masterData: {
      defaultRegionCallingCode: string;
    };
  };
  turnsWithLeaders: {
    turn: {
      id: number;
      route: {
        name: string;
      };
      shift: {
        startDate: string;
        endDate: string;
      };
      turnAssignments?: unknown[] | null;
    };
    turnLeader: {
      id: number;
      firstName: string;
      lastName: string;
      phone: string;
    };
  }[];
};

export const ShiftTurnLeaders = (props: ShiftTurnLeadersProps) =>
  props.turnsWithLeaders.length > 0 ? (
    <Spacings.Inline scale="l">
      <Typography variant="body2" color="textSecondary">
        {moment(props.turnsWithLeaders[0].turn.shift.startDate).format('LT')} -{' '}
        {moment(props.turnsWithLeaders[0].turn.shift.endDate).format('LT')}
      </Typography>
      <div className={styles['turn-leader-list']}>
        <Spacings.Stack scale="m">
          {props.turnsWithLeaders.map(({ turn, turnLeader }) => (
            <button
              key={turn.id}
              type="button"
              className={styles['turn-leader-list-item']}
              onClick={() => props.onPublisherClick(turnLeader)}
            >
              <Spacings.Stack scale="xs">
                <Typography variant="body2" color="textSecondary">
                  {turn.route.name} (
                  {turn.turnAssignments ? turn.turnAssignments.length : 0}{' '}
                  <FormattedMessage {...messages.participants} />)
                </Typography>
                <Spacings.Stack scale="none">
                  <Typography>
                    {turnLeader.firstName} {turnLeader.lastName}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {toNational(
                      turnLeader.phone,
                      props.settings?.masterData?.defaultRegionCallingCode
                    )}
                  </Typography>
                </Spacings.Stack>
              </Spacings.Stack>
            </button>
          ))}
        </Spacings.Stack>
      </div>
    </Spacings.Inline>
  ) : null;

type ShiftsTurnLeadersCardProps = {
  onPublisherClick: (publisher: { id: number; phone: string }) => void;
  settings: {
    masterData: {
      defaultRegionCallingCode: string;
    };
  };
  turnId: number;
};

export const ShiftsTurnLeadersCard = (props: ShiftsTurnLeadersCardProps) => {
  const { data, isFetching } = useOtherTeamLeaders({ id: props.turnId });

  return (
    <InformationalSection
      title={<FormattedMessage {...messages.turnLeaders} />}
    >
      <Spacings.Inset>
        <Spacings.Stack scale="l">
          {!isFetching && data
            ? Object.entries(data).map(([shiftId, turnsWithLeaders]) => (
                <ShiftTurnLeaders
                  key={shiftId}
                  turnsWithLeaders={turnsWithLeaders!}
                  onPublisherClick={props.onPublisherClick}
                  settings={props.settings}
                />
              ))
            : null}
        </Spacings.Stack>
      </Spacings.Inset>
    </InformationalSection>
  );
};

export default ShiftsTurnLeadersCard;
